class AfterpayStyler extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.styledElements = new WeakSet();
  }

  connectedCallback() {
    this.applyStyles();

    this.observer = new MutationObserver(() => {
      this.applyStyles();
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  applyStyles() {
    const afterpay = document.querySelectorAll('afterpay-placement');
    if (afterpay.length === 0) return;

    afterpay.forEach(element => {
      if (!element.shadowRoot) return;
      if (this.styledElements.has(element)) return;

      let applied = false;

      if (element.classList.contains('product-gift__afterpay')) {
        const text = element.shadowRoot.querySelector('.afterpay-text2');
        if (text) {
          text.style.fontFamily = 'Arial';
          text.style.fontSize = '16px';
          text.style.color = '#000';
          text.style.letterSpacing = '0';
        }

        const fill = element.shadowRoot.querySelector('.afterpay-logo.logo-cashappafterpay svg g path');
        if (fill) {
          fill.style.fill = 'black';
          applied = true;
        }
      }

      const paragraph = element.shadowRoot.querySelector('.afterpay-paragraph');
      if (paragraph) {
        paragraph.style.color = '#2C2E35';
        paragraph.style.fontFamily = 'Inter, Arial, sans-serif';
        paragraph.style.fontSize = '16px';
        paragraph.style.fontStyle = 'normal';
        paragraph.style.letterSpacing = '0';

        const mainText = paragraph.querySelector('.afterpay-main-text');
        if (mainText) mainText.style.order = '2';
        const logoLink = paragraph.querySelector('.afterpay-logo-link');
        if (logoLink) logoLink.style.order = '1';
        const infoLink = paragraph.querySelector('#logo-link');
        if (infoLink && infoLink.parentElement !== paragraph) {
          paragraph.appendChild(infoLink);
          infoLink.style.order = '3';
        }
        applied = true;
      }

      const text1 = element.shadowRoot.querySelector('.afterpay-text1');
      if (text1) {
        text1.style.display = 'none';
        applied = true;
      }

      const text2 = element.shadowRoot.querySelector('.afterpay-text2');
      if (text2) {
        text2.style.display = 'block';
        text2.style.letterSpacing = '0';
        applied = true;
      }

      const fill = element.shadowRoot.querySelector('.afterpay-logo.logo-cashappafterpay svg g path');
      if (fill) {
        fill.style.fill = 'black';
        applied = true;
        element.shadowRoot.querySelector('.afterpay-logo.logo-cashappafterpay').style.width = '82px';
        element.shadowRoot.querySelector('.afterpay-logo.logo-cashappafterpay svg').style.width = '82px';
        element.shadowRoot.querySelector('.afterpay-text2').style.display='inline'
      }

      if (applied) {
        this.styledElements.add(element);
      }
    });
  }
}

customElements.define('afterpay-styler', AfterpayStyler);

if (!document.querySelector('afterpay-styler')) {
  document.body.appendChild(document.createElement('afterpay-styler'));
}
